"use strict";
/**
 * Copyright © 2019 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TooltipWithInfoIcon = void 0;
const react_1 = __importDefault(require("react"));
const Info_1 = __importDefault(require("@mui/icons-material/Info"));
const material_1 = require("@mui/material");
const makeStyles_1 = __importDefault(require("@mui/styles/makeStyles"));
const constants_1 = require("../../constants");
const useStyles = (props) => makeStyles_1.default({
    iconStyle: {
        margin: '0 0 0 0.625rem',
        color: props.tooltipColor,
        height: '1.2rem',
        width: '1.2rem',
        cursor: 'pointer',
        '&:hover': {
            color: props.colorOnHover,
        },
    },
});
/**
 *
 * @param {string} tooltipText The actual text that the tooltip will display, always pass the translated text.
 * @param {TooltipProps=} [tooltipPlacement] The placement for the tooltip
 * @description Returns a tooltip component wrapped over an 'i' icon
 */
exports.TooltipWithInfoIcon = (props) => {
    const { title = '', placement = 'bottom', colorOnHover = constants_1.themeOptions.palette.black.main, tooltipColor = constants_1.themeOptions.palette.black.light } = props, restOfTheProps = __rest(props, ["title", "placement", "colorOnHover", "tooltipColor"]);
    const classes = useStyles({ tooltipColor, colorOnHover })();
    return (react_1.default.createElement(material_1.Tooltip, Object.assign({ title: title, placement: placement, arrow: true }, restOfTheProps),
        react_1.default.createElement(Info_1.default, { className: classes.iconStyle })));
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVG9vbHRpcFdpdGhJbmZvSWNvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL1Rvb2x0aXBXaXRoSW5mb0ljb24vVG9vbHRpcFdpdGhJbmZvSWNvbi50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBOzs7Ozs7R0FNRzs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFFSCxrREFBMEI7QUFDMUIsb0VBQWdEO0FBQ2hELDRDQUFzRDtBQUN0RCx3RUFBZ0Q7QUFFaEQsK0NBQStDO0FBWS9DLE1BQU0sU0FBUyxHQUFHLENBQUMsS0FBcUQsRUFBRSxFQUFFLENBQzFFLG9CQUFVLENBQUM7SUFDVCxTQUFTLEVBQUU7UUFDVCxNQUFNLEVBQUUsZ0JBQWdCO1FBQ3hCLEtBQUssRUFBRSxLQUFLLENBQUMsWUFBWTtRQUN6QixNQUFNLEVBQUUsUUFBUTtRQUNoQixLQUFLLEVBQUUsUUFBUTtRQUNmLE1BQU0sRUFBRSxTQUFTO1FBQ2pCLFNBQVMsRUFBRTtZQUNULEtBQUssRUFBRSxLQUFLLENBQUMsWUFBWTtTQUMxQjtLQUNGO0NBQ0YsQ0FBQyxDQUFDO0FBRUw7Ozs7O0dBS0c7QUFFVSxRQUFBLG1CQUFtQixHQUFHLENBQUMsS0FBMkIsRUFBRSxFQUFFO0lBQ2pFLE1BQU0sRUFDSixLQUFLLEdBQUcsRUFBRSxFQUNWLFNBQVMsR0FBRyxRQUFRLEVBQ3BCLFlBQVksR0FBRyx3QkFBWSxDQUFDLE9BQU8sQ0FBQyxLQUFLLENBQUMsSUFBSSxFQUM5QyxZQUFZLEdBQUcsd0JBQVksQ0FBQyxPQUFPLENBQUMsS0FBSyxDQUFDLEtBQUssS0FFN0MsS0FBSyxFQURKLGNBQWMsVUFDZixLQUFLLEVBTkgsc0RBTUwsQ0FBUSxDQUFDO0lBQ1YsTUFBTSxPQUFPLEdBQUcsU0FBUyxDQUFDLEVBQUUsWUFBWSxFQUFFLFlBQVksRUFBRSxDQUFDLEVBQUUsQ0FBQztJQUU1RCxPQUFPLENBQ0wsOEJBQUMsa0JBQU8sa0JBQUMsS0FBSyxFQUFFLEtBQUssRUFBRSxTQUFTLEVBQUUsU0FBUyxFQUFFLEtBQUssVUFBSyxjQUFjO1FBQ25FLDhCQUFDLGNBQVEsSUFBQyxTQUFTLEVBQUUsT0FBTyxDQUFDLFNBQVMsR0FBSSxDQUNsQyxDQUNYLENBQUM7QUFDSixDQUFDLENBQUMifQ==